module.exports = __webpack_public_path__ + "hand-num-icon.png?f7a8820d486d2de1992e1e3d98ec4c73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand-num-icon.png
// module id = 24
// module chunks = 0